import { useFormik, Form, FormikProvider } from "formik";
import { Button } from "styled";
import Model from "components/Modal";
import {
  createDocument,
  getAllData,
  updateDocumentByID,
} from "apis/customApiHandler";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import { useState } from "react";
import { useEffect } from "react";
import {DownloadAggrement} from "./DownloadAggrement";
import { TD } from 'styled/table';
import InputField from "../formik/InputField";
import { formatDate, formattedDate } from "utils/helpers";
import { useLocation } from "react-router-dom";
import { trackEvent } from "utils/analytics";
import { ANALYTICS_EVENTS } from "utils/analyticsEvents";

const AddAggrement = ({ data, handleClick,setShowAgreement,getData,setSelectedAgreement }) => {
  const queryClient = useQueryClient();
  const location = useLocation();
  const [files, setFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState([]);
  const[isSubmitting,setIsSubmitting]=useState(false);

  console.log('data--',data);

  const trackAgreementEvent = (eventName, vehicleNumber, errMsg = null) => {
    return trackEvent(eventName, "Vehicles", location.pathname, { vehicle_number: vehicleNumber, errMsg: errMsg });
  };

  const formik = useFormik({
    initialValues: {
      registrationNumber: data?.registrationNumber || "",
      agreement:"",
      agreements: data?.agreements || [],
    },
    onSubmit: async (values) => {
      setIsSubmitting(true);
      try {
        Object.keys(values).forEach((key) => {
          if (values[key] === "") {
            delete values[key];
          }
        });

        const formattedValues = { ...values };

        if (Array.isArray(values.agreement)) {
          formattedValues.agreement = values.agreement[0];
        }

        const result = data
          ? await updateDocumentByID("vehicle", data._id, formattedValues)
          : await createDocument("vehicle", formattedValues);
        if (result) {
          trackAgreementEvent(ANALYTICS_EVENTS.SYS_UPDATE_AGREEMENT_VEHICLE_SUCCESS, data?.registrationNumber);
          toast.success("Agreement uploaded successfully");
        }
        queryClient.invalidateQueries("vehicles", { refetchActive: true });
        getData();
        handleClick();
        setIsSubmitting(false);
      } catch (error) {
        trackAgreementEvent(ANALYTICS_EVENTS.SYS_UPDATE_AGREEMENT_VEHICLE_ERROR, data?.registrationNumber, error?.message);
        setIsSubmitting(false);
      }
    },

    validate: (values) => {
      const errors = {};
      if (!values.agreement) errors.agreement = "Required";
      if (!values.registrationNumber) errors.registrationNumber = "Required";
     
      return errors;
    },
  });

  const handleFileDelete = (index) => {
    const updatedFiles = files?.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  console.log('data--',data);
 
  return (
    <Model
      handleClick={handleClick}
      title={data ? `Update Agreement ${data?.registrationNumber}` : "Upload Agreement"}
      className="max-w-2xl"
    >
      <FormikProvider value={formik}>
        <Form className="px-5 text-gray-800 font-medium text-base w-full">


          <div className="col-span-2 mt-5">
          <label className="text-lg font-medium underline">Upload Agreement File:</label>

          <InputField
              type="file"
               name="agreement"
              formik={formik}
              required={true}
              limit={1}
              compressImage={true}
              maxSize={2 * 1024 * 1024}
              accept="image/png, image/jpeg, image/jpg,application/pdf"
              validateFileType={true}
              fileType = "(Pdf,Jpg,Jpeg,png)"
            />
          </div>


          {data.agreement ? <DownloadAggrement data={data.agreement}/>: <div className= "rounded-lg justify-center mx-auto mt-4 flex p-2 w-64 bg-gray-100"> No Agreement Uploaded </div>}

        </Form>

        {data?.agreements?.slice()?.reverse()?.map && (
        <div className="col-span-2 overflow-x-auto mt-6 mb-4">
          <h1 className="mb-2 text-center">Agreement History</h1>
          <table className="w-[95%] max-w-full mx-auto divide-y divide-gray-200">
            <thead className="text-gray-600 bg-gray-100 rounded-lg">
              <tr className="rounded-md">
                <th scope="col" className="px-6 py-3 text-center text-sm font-medium border border-gray-300">
                  Uploaded By
                </th>
                <th scope="col" className="px-6 py-3 text-center text-sm font-medium border border-gray-300">
                  Uploaded On
                </th>
                <th scope="col" className="px-6 py-3 text-center text-sm font-medium border border-gray-300">
                  Agreement File
                </th>
              </tr>
            </thead>
            <tbody className="text-gray-600">
              {data?.agreements?.slice()?.reverse()?.map((agreement, index) => {
                console.log('agreement----',data);
                return (
                  <tr key={index} className="w-full gap-x-2">
                    <td className="whitespace-nowrap rounded-sm text-center border border-gray-300">
                      {agreement.uploadedBy}
                    </td>
                    <td className="whitespace-nowrap rounded-sm text-center border border-gray-300">
                      {formattedDate(agreement.dateOfUpload)}
                    </td>
                    <td
                      className="whitespace-nowrap rounded-sm text-center cursor-pointer border border-gray-300"
                      onClick={() => {
                        setShowAgreement(true);
                        handleClick();
                        setSelectedAgreement(agreement)
                      }}
                    >
                      <div className="text-green-400 underline">
                      Click to View
                      </div> 
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
)}



        <div className="mt-5 px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            Cancel
          </Button>
          <Button type="button" bgPrimary onClick={() => { trackAgreementEvent(ANALYTICS_EVENTS.CLICK_UPDATE_AGREEMENT_BUTTON, data?.registrationNumber); formik.handleSubmit(); }}
          disabled={isSubmitting || !formik.values.agreement}
          >
            Upload Document
          </Button>
        </div>
      </FormikProvider>
    </Model>
  );
};

export default AddAggrement;

